import { createSelector } from '@reduxjs/toolkit';

import { getFilters } from './getFilters';

export const getRooms = createSelector(getFilters, state => state.rooms);
